import React from 'react';
import PropTypes from 'prop-types';
import Number from '../../Number';

AuctionHeaderQuantity.propTypes = {
    quantity: PropTypes.number.isRequired,
};

function AuctionHeaderQuantity(props) {
    const {
        quantity,
    } = props;
    return (
        <div className="auction-header--quantity">
            <Number value={quantity} />
        </div>
    );
}

export default AuctionHeaderQuantity;
